import { MdsIcon } from "@/design-system/components/icon";
import styled from "@emotion/styled";
import { Link } from "react-aria-components";
import { ChipColor } from "./chip.types";

export const StyledInner = styled.div<{ maxWidth?: number | string }>`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.xs};
  max-width: ${({ maxWidth }) =>
    typeof maxWidth === "number" ? `${maxWidth}px` : maxWidth || "200px"};
  min-width: 0;
`;

export const StyledText = styled.span`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
  padding-right: ${({ theme }) => theme.spacing.xxs};
  font-size: ${({ theme }) => theme.fontSizes.small};
  line-height: ${({ theme }) => theme.lineHeights.xsmall};
`;

export const StyledIcon = styled(MdsIcon)`
  color: ${({ theme }) => theme.colors.grey.x600};
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    font-size: ${({ theme }) => theme.fontSizes.xxsmall};
    width: 12px;
    height: 12px;
  }
`;

export const StyledChipButton = styled(Link)<{ $color: ChipColor }>`
  display: flex;
  white-space: nowrap;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex-wrap: nowrap;
  border-radius: ${({ theme }) => theme.borderRadius.medium}px;
  outline: none;
  border: none;
  cursor: pointer;
  transition: 0.25s ease;
  user-select: none;

  /* Size xs styles (same as MDSButton xs) */
  font-weight: ${({ theme }) => theme.fontWeights.regular};
  font-size: ${({ theme }) => theme.fontSizes.xxsmall};
  padding: ${({ theme }) => theme.spacing.xs};
  line-height: ${({ theme }) => theme.lineHeights.xxsmall};

  /* Conditional styles based on color */
  ${({ $color, theme }) => {
    if ($color === "grey") {
      return `
        background-color: ${theme.colors.grey.x50};
        color: ${theme.colors.grey.x800};
        box-shadow: none;

        &[data-hovered]:not([data-disabled]) {
          background-color: ${theme.colors.grey.x100};
          transition: 0.2s all;
        }

        &[data-pressed]:not([data-disabled]) {
          background-color: ${theme.colors.grey.x200};
          transition: 0.2s all;
        }

        &[data-disabled] {
          opacity: 0.4;
          cursor: not-allowed;
          background-color: ${theme.colors.grey.x50};
        }
      `;
    } else {
      // Default kind - matches MDSButton highlight color
      return `
        background-color: ${theme.colors.white};
        color: ${theme.colors.grey.x800};
        box-shadow: none;

        &[data-hovered]:not([data-disabled]) {
          background-color: ${theme.colors.grey.x50};
          transition: 0.2s all;
        }

        &[data-pressed]:not([data-disabled]) {
          background-color: ${theme.colors.grey.x25};
          transition: 0.2s all;
        }

        &[data-disabled] {
          opacity: 0.4;
          cursor: not-allowed;
          background-color: ${theme.colors.white};
        }
      `;
    }
  }}
`;
